// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("img/search.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("img/search-focus.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

html {
  height: 100%;
}
.noHover {
  pointer-events: none;
}

.App-logo {
  animation: App-logo-spin infinite 20s linear;
  height: 80px;
}

.App-header {
  background-color: #222;
  height: 150px;
  padding: 20px;
  color: white;
}
.ag-header-cell-text {
  color: white;
}
.ag-set-filter-select-all {
  margin-top: 5px;
}
.ta-logo {
  height: 26px;
  margin-left: 10px;
  position: relative;
  top: 6px;
}
.ta-bullseye {
  position: relative;
  top: 5px;
}
.ta-navbar {
  height: 45px;
  padding: 0px;
  /* box-shadow: 0px 2px 4px rgba(88, 89, 91, 1); */
}
.ta-apps-brand {
  padding-top: 0px;
  padding-bottom: 0px;
}
.container-fluid {
  padding: 0px !important;
  padding-left: 0px;
}
.container {
  padding: 0px;
  margin-left: 0px !important;
  margin-right: 0px !important;
  width: 100% !important;
}

.App-title {
  font-size: 1.5em;
}

.App-intro {
  font-size: large;
}

.flex-container {
  list-style: none;
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.login-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
  min-width: 100px;
  text-align: center;
}

.login-msg {
  margin-bottom: 10px;
  display: flex;
}

.login-heading {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  margin-top: 60px;
}
.login-info {
  margin-left: auto;
  margin-right: auto;
  margin-top: 60px;
  text-align: center;
  font-size: 12px;
}
.login-help {
  position: relative;
  top: -1px;
}
.ta-tabs-header {
  font-size: 18px;
  font-weight: 600;
  color: #58595b;
  padding-right: 10px;
  padding-left: 10px;
}
.ta-tabs-header-icons {
  font-size: 18px;
  font-weight: 600;
  color: #58595b;
}
.input-box {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: solid 1px #707070;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 0px 6px;
  background-size: 16px;
  text-indent: 24px;
  font-size: 16px;
  height: fit-content;
}

.input-box::placeholder {
  font-style: italic;
  font-size: 16px;
}

.input-box:focus,
.input-box.has-value {
  border-bottom-color: #4285f4;
  outline: none;
  border-top: none;
  border-left: none;
  border-right: none;
  color: #4285f4;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.input-box:focus::placeholder {
  color: #4285f4;
}
svg:hover {
  fill: black;
}
.report-list-router-div {
  width: 100%;
  padding-bottom: 10px;
}
.ta-report {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.action-buttons {
  padding-right: 10px;
}
.Toastify__toast-container {
  z-index: 100000 !important;
}

.Toastify__toast--success {
  color: #155724 !important;
  background-color: #d4edda !important;
  border-color: #c3e6cb !important;
  border-radius: 2px !important;
}
/*
.Toastify__toast--warning {
  background: #f1c40f;
}*/

.Toastify__close-button--success {
  color: #155724 !important;
}

.Toastify__close-button--error {
  color: #721c24 !important;
}

.Toastify__toast--error {
  color: #721c24 !important;
  background-color: #f8d7da !important;
  border-color: #f5c6cb !important;
  border-radius: 2px !important;
}
/*
.Toastify__toast {
} */

/* .btn-primary {
  background-color: rgba(0, 126, 167, 1) !important;
  border-color: 1px solid rgba(0, 126, 167, 1) !important;
} */
.error-div {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 2px;
  font-size: 12px;
}
.validation-error-div {
  max-height: 200px;
  overflow: auto;
}
.error-row {
  white-space: nowrap;
  font-size: 12px;
  padding: 1px 1px 1px 4px;
}

.vr {
  border: 1px solid #ccc;
  height: 85%;
  margin-top: 7px;
}

.menu-item:hover {
  background-color: #cfeaf8;
}

.menu-item:hover > svg {
  fill: black;
}

.gear-menu {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}

.info-text {
  font-style: italic;
  color: #666;
}
.secondary-app-title {
  margin-right: 0px;
  cursor: default;
  font-weight: 600;
}
.secondary-nav-chevron {
  width: 20px;
  margin-left: 0px;
  margin-right: 20px;
  margin-top: 2px;
}

.ta-button {
  cursor: pointer;
  height: fit-content;
  border-style: none;
  border-radius: 2px;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  /* margin-left: 4px;
  margin-right: 4px; */
  /* line-height: 28px; */
  font-size: 16px;
}

.ta-button-primary {
  background-color: rgba(0, 126, 167, 1);
  border: 1px solid rgba(0, 126, 167, 1);
  color: #fff;
}
.ta-button-primary:hover {
  background-color: #006885;
  border: 1px solid #006885;
  /* color: #fff; */
}

.ta-button-secondary {
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(112, 112, 112, 1);
  color: rgba(112, 112, 112, 1);
}

.ta-button-secondary:hover {
  background-color: #e0e0e0;
  border: 1px solid rgba(112, 112, 112, 1);
  color: rgba(112, 112, 112, 1);
}

.ta-button-disabled {
  background-color: rgba(181, 181, 181, 1);
  border: 1px solid rgba(181, 181, 181, 1);
  color: rgba(255, 255, 255, 1);
  cursor: not-allowed;
}

.ta-button-danger {
  background-color: #b93f34;
  border: 1px solid #b93f34;
  color: white;
}

.ta-button-danger:hover {
  background-color: #991b1b;
  border: 1px solid #b93f34;
  color: white;
}

.dot {
  animation: ellipsisAnimation 1.5s infinite;
  opacity: 0;
}
.dot:nth-child(1) {
  animation-delay: 0.25s;
}
.dot:nth-child(2) {
  animation-delay: 0.5s;
}
.dot:nth-child(3) {
  animation-delay: 0.75s;
}

@keyframes ellipsisAnimation {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

@keyframes rotateIn {
  0% {
    transform: rotate(-90deg) scale(0.8);
    opacity: 0;
  }
  100% {
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }
}

.app-page-title {
  color: rgb(88, 89, 91);
  font-size: 18px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iDAAiD;AACnD;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,yDAAqC;EACrC,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yDAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;;;EAGE;;AAEF;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;;GAEG;;AAEH;;;GAGG;AACH;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB;sBACoB;EACpB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oCAAoC;IACpC,UAAU;EACZ;EACA;IACE,gCAAgC;IAChC,UAAU;EACZ;AACF;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".App {\n  text-align: center;\n}\n\nhtml {\n  height: 100%;\n}\n.noHover {\n  pointer-events: none;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 80px;\n}\n\n.App-header {\n  background-color: #222;\n  height: 150px;\n  padding: 20px;\n  color: white;\n}\n.ag-header-cell-text {\n  color: white;\n}\n.ag-set-filter-select-all {\n  margin-top: 5px;\n}\n.ta-logo {\n  height: 26px;\n  margin-left: 10px;\n  position: relative;\n  top: 6px;\n}\n.ta-bullseye {\n  position: relative;\n  top: 5px;\n}\n.ta-navbar {\n  height: 45px;\n  padding: 0px;\n  /* box-shadow: 0px 2px 4px rgba(88, 89, 91, 1); */\n}\n.ta-apps-brand {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n.container-fluid {\n  padding: 0px !important;\n  padding-left: 0px;\n}\n.container {\n  padding: 0px;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  width: 100% !important;\n}\n\n.App-title {\n  font-size: 1.5em;\n}\n\n.App-intro {\n  font-size: large;\n}\n\n.flex-container {\n  list-style: none;\n  -ms-box-orient: horizontal;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -moz-flex;\n  display: -webkit-flex;\n  display: flex;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.login-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-top: 30px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 10px;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 400px;\n  min-width: 100px;\n  text-align: center;\n}\n\n.login-msg {\n  margin-bottom: 10px;\n  display: flex;\n}\n\n.login-heading {\n  text-align: center;\n  font-weight: 600;\n  font-size: 20px;\n  margin-top: 60px;\n}\n.login-info {\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 60px;\n  text-align: center;\n  font-size: 12px;\n}\n.login-help {\n  position: relative;\n  top: -1px;\n}\n.ta-tabs-header {\n  font-size: 18px;\n  font-weight: 600;\n  color: #58595b;\n  padding-right: 10px;\n  padding-left: 10px;\n}\n.ta-tabs-header-icons {\n  font-size: 18px;\n  font-weight: 600;\n  color: #58595b;\n}\n.input-box {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: solid 1px #707070;\n  background-image: url(img/search.png);\n  background-repeat: no-repeat;\n  background-position: 0px 6px;\n  background-size: 16px;\n  text-indent: 24px;\n  font-size: 16px;\n  height: fit-content;\n}\n\n.input-box::placeholder {\n  font-style: italic;\n  font-size: 16px;\n}\n\n.input-box:focus,\n.input-box.has-value {\n  border-bottom-color: #4285f4;\n  outline: none;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  color: #4285f4;\n  background-image: url(img/search-focus.png);\n}\n\n.input-box:focus::placeholder {\n  color: #4285f4;\n}\nsvg:hover {\n  fill: black;\n}\n.report-list-router-div {\n  width: 100%;\n  padding-bottom: 10px;\n}\n.ta-report {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.action-buttons {\n  padding-right: 10px;\n}\n.Toastify__toast-container {\n  z-index: 100000 !important;\n}\n\n.Toastify__toast--success {\n  color: #155724 !important;\n  background-color: #d4edda !important;\n  border-color: #c3e6cb !important;\n  border-radius: 2px !important;\n}\n/*\n.Toastify__toast--warning {\n  background: #f1c40f;\n}*/\n\n.Toastify__close-button--success {\n  color: #155724 !important;\n}\n\n.Toastify__close-button--error {\n  color: #721c24 !important;\n}\n\n.Toastify__toast--error {\n  color: #721c24 !important;\n  background-color: #f8d7da !important;\n  border-color: #f5c6cb !important;\n  border-radius: 2px !important;\n}\n/*\n.Toastify__toast {\n} */\n\n/* .btn-primary {\n  background-color: rgba(0, 126, 167, 1) !important;\n  border-color: 1px solid rgba(0, 126, 167, 1) !important;\n} */\n.error-div {\n  color: #721c24;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 2px;\n  font-size: 12px;\n}\n.validation-error-div {\n  max-height: 200px;\n  overflow: auto;\n}\n.error-row {\n  white-space: nowrap;\n  font-size: 12px;\n  padding: 1px 1px 1px 4px;\n}\n\n.vr {\n  border: 1px solid #ccc;\n  height: 85%;\n  margin-top: 7px;\n}\n\n.menu-item:hover {\n  background-color: #cfeaf8;\n}\n\n.menu-item:hover > svg {\n  fill: black;\n}\n\n.gear-menu {\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);\n}\n\n.info-text {\n  font-style: italic;\n  color: #666;\n}\n.secondary-app-title {\n  margin-right: 0px;\n  cursor: default;\n  font-weight: 600;\n}\n.secondary-nav-chevron {\n  width: 20px;\n  margin-left: 0px;\n  margin-right: 20px;\n  margin-top: 2px;\n}\n\n.ta-button {\n  cursor: pointer;\n  height: fit-content;\n  border-style: none;\n  border-radius: 2px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-left: 8px;\n  padding-right: 8px;\n  /* margin-left: 4px;\n  margin-right: 4px; */\n  /* line-height: 28px; */\n  font-size: 16px;\n}\n\n.ta-button-primary {\n  background-color: rgba(0, 126, 167, 1);\n  border: 1px solid rgba(0, 126, 167, 1);\n  color: #fff;\n}\n.ta-button-primary:hover {\n  background-color: #006885;\n  border: 1px solid #006885;\n  /* color: #fff; */\n}\n\n.ta-button-secondary {\n  background-color: rgba(255, 255, 255, 1);\n  border: 1px solid rgba(112, 112, 112, 1);\n  color: rgba(112, 112, 112, 1);\n}\n\n.ta-button-secondary:hover {\n  background-color: #e0e0e0;\n  border: 1px solid rgba(112, 112, 112, 1);\n  color: rgba(112, 112, 112, 1);\n}\n\n.ta-button-disabled {\n  background-color: rgba(181, 181, 181, 1);\n  border: 1px solid rgba(181, 181, 181, 1);\n  color: rgba(255, 255, 255, 1);\n  cursor: not-allowed;\n}\n\n.ta-button-danger {\n  background-color: #b93f34;\n  border: 1px solid #b93f34;\n  color: white;\n}\n\n.ta-button-danger:hover {\n  background-color: #991b1b;\n  border: 1px solid #b93f34;\n  color: white;\n}\n\n.dot {\n  animation: ellipsisAnimation 1.5s infinite;\n  opacity: 0;\n}\n.dot:nth-child(1) {\n  animation-delay: 0.25s;\n}\n.dot:nth-child(2) {\n  animation-delay: 0.5s;\n}\n.dot:nth-child(3) {\n  animation-delay: 0.75s;\n}\n\n@keyframes ellipsisAnimation {\n  0%,\n  100% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes rotateIn {\n  0% {\n    transform: rotate(-90deg) scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    transform: rotate(0deg) scale(1);\n    opacity: 1;\n  }\n}\n\n.app-page-title {\n  color: rgb(88, 89, 91);\n  font-size: 18px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
